/**
 * Add hover intent delay to desktop menus
 * Prevents accidental menu switching when moving mouse from menu item to dropdown
 */

(function() {
  'use strict';

  // Enhanced hover detection with 250ms delay
  const hoverIntentDetectHover = function(event) {
    if (this.trigger !== "hover") {
      return;
    }

    if (event.type === "mouseover") {
      // Clear any pending close timer
      clearTimeout(this._hoverTimer);

      // Only add delay if menu is currently closed
      if (!this.hasAttribute('open')) {
        // Clear any previous opening timer
        clearTimeout(this._hoverOpenTimer);

        // Add 250ms delay before opening (hover intent / debounce)
        this._hoverOpenTimer = setTimeout(() => {
          this.open = true;
        }, 250);
      }
    } else {
      // Mouseout event
      const relatedTarget = event.relatedTarget;

      // If related target is null or not contained within this menu, we're truly leaving
      if (!relatedTarget || !this.contains(relatedTarget)) {
        // Cancel any pending open
        clearTimeout(this._hoverOpenTimer);

        // Schedule close
        this._hoverTimer = setTimeout(() => this.open = false, this.mouseOverDelayTolerance);
      }
    }
  };

  // Check if customElements API is available
  if (!window.customElements) {
    return;
  }

  // INTERCEPT customElements.define() to override BEFORE any instances are created
  const originalDefine = window.customElements.define;

  window.customElements.define = function(name, constructor, options) {
    if (name === 'dropdown-disclosure' || name === 'mega-menu-disclosure') {
      // Override the prototype BEFORE the element is defined
      constructor.prototype._detectHover = hoverIntentDetectHover;
    }

    // Call the original define
    return originalDefine.call(this, name, constructor, options);
  };
})();
